import { provide } from 'vue'

export const NOVEL_COVER_LOCALES = Symbol('novel_cover_locales')

/**
 * 编辑页把按语言封面交给作品概览里的封面区（层层透传属性太长）。
 * @param {ReturnType<typeof import('./useNovelPack.js').useNovelPack>} novel
 */
export function provideNovelCoverLocales(novel) {
  provide(NOVEL_COVER_LOCALES, {
    cover_locales: novel.cover_locales,
    upload: novel.upload_cover_locale,
    clear: novel.clear_cover_locale,
  })
}
